import { Config, ConfigEnvironment } from './config.types';

const preConfig: ConfigEnvironment = {
    development: {
        apiUrl: 'http://localhost:8000/api',
        logLevel: 'debug',
    },
    production: {
        apiUrl: 'https://portal.saintsburg.com/api',
        logLevel: 'error',
    }
};

const environment: keyof ConfigEnvironment = (process.env.NODE_ENV as 'development' | 'production') || 'development';

const config: Config = {
    ...preConfig[environment],
    ablyAuthTokenUrl: process.env.REACT_APP_ABLY_AUTH_TOKEN_URL,
    oauthStateKey: process.env.REACT_APP_OAUTH_STATE_KEY,
    oauthResponse: process.env.REACT_APP_OAUTH_RESPONSE,
    exchangeCodeForTokenMethod: process.env.REACT_APP_EXCHANGE_CODE_FOR_TOKEN_METHOD as 'GET' | 'POST',
    oauthAuthUrl: process.env.REACT_APP_OAUTH_AUTH_URL,
    oauthClientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
    oauthResponseType: process.env.REACT_APP_OAUTH_RESPONSE_TYPE as 'code' | 'token',
    oauthTokenUrl: preConfig[environment].apiUrl + '/token',
    amazonDirUrl: process.env.REACT_APP_AMAZON_DIR_URL,
    amazonPdfUrl: process.env.REACT_APP_AMAZON_DIR_URL + '/pdf',
    portraitMemos: process.env.REACT_APP_PORTRAIT_MEMOS?.split(',') || [],
};

export default config;